/**
 * Beeldformaten en standaardwaarden.
 *
 * De project-fps is de enige tijdbasis van de app. Alle posities in het
 * projectmodel zijn frames op deze fps. Seconden bestaan alleen in de
 * gebruikersinterface en bij het omrekenen naar bronmedia.
 */

export const PROJECT_FPS = 30;

/** Maximale projectduur in fase 1 (seconden). */
export const MAX_PROJECT_DUUR_SECONDEN = 60;

/** Minimale en maximale exportresolutie. */
export const MAX_EXPORT_HOOGTE = 1080;

export type BeeldformaatId = '16:9' | '9:16' | '1:1' | '4:5';

export interface Beeldformaat {
  id: BeeldformaatId;
  label: string;
  breedte: number;
  hoogte: number;
}

export const BEELDFORMATEN: Record<BeeldformaatId, Beeldformaat> = {
  '16:9': { id: '16:9', label: 'Landscape 16:9', breedte: 1920, hoogte: 1080 },
  '9:16': { id: '9:16', label: 'Verticaal 9:16', breedte: 1080, hoogte: 1920 },
  '1:1': { id: '1:1', label: 'Vierkant 1:1', breedte: 1080, hoogte: 1080 },
  '4:5': { id: '4:5', label: 'Portret 4:5', breedte: 1080, hoogte: 1350 },
};

export const STANDAARD_BEELDFORMAAT: BeeldformaatId = '16:9';

/** Bestandsextensies en MIME-types die als video worden geaccepteerd. */
export const TOEGESTANE_VIDEO_MIME = [
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/x-matroska',
  'video/x-msvideo',
] as const;

export const TOEGESTANE_AFBEELDING_MIME = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
] as const;

export const TOEGESTANE_AUDIO_MIME = [
  'audio/mpeg',
  'audio/mp4',
  'audio/aac',
  'audio/wav',
  'audio/x-wav',
  'audio/ogg',
  'audio/webm',
  'audio/flac',
] as const;

/** Harde uploadlimiet. Los van wat de proxy toestaat. */
export const MAX_UPLOAD_BYTES = 2 * 1024 * 1024 * 1024; // 2 GB

/**
 * Videocodecs die Remotion (headless Chrome) betrouwbaar kan afspelen.
 * Wat hier niet in staat, wordt geweigerd met een duidelijke melding.
 */
export const ONDERSTEUNDE_VIDEOCODECS = ['h264', 'vp8', 'vp9', 'av1', 'prores'] as const;

/** Audiocodecs die we in de preview en export ondersteunen. */
export const ONDERSTEUNDE_AUDIOCODECS = ['aac', 'mp3', 'opus', 'vorbis', 'pcm_s16le', 'pcm_s24le', 'flac'] as const;
